import React, { useEffect } from 'react';
import _ from 'lodash'
import { connect } from 'react-redux'
import { Container } from '@sencha/ext-modern'

import FormMessage from '../FormMessage'
import { useInstData } from 'tyan/public/hooks'
import { getTasks } from '../../menus'
import Tasks from './Tasks'
import Task from './Task'

const MyTasks = props => {
	const {
		me, setState,
		me: { state: {
			tasks = null, currentTask = null, noTask = false
		} }
	} = useInstData(props)

	const { reloadStamp, that, maxFetch = 10 } = props
	const handleTasksLoaded = () => setState({})
	const handleTaskSwitch = (currentTask) => setState({ currentTask })

	useEffect(() => {
		const { menu } = props
		setState({ tasks: _.cloneDeep(getTasks(menu)) })
	}, [])

	useEffect(() => {
		if (!tasks) return
		let total = 0
		for (const t of tasks) {
			if (t.total == undefined) {
				noTask && setState({ noTask: false })
				return
			}
			total += t.total
		}
		!total && !noTask && setState({ noTask: true })
		total && noTask && setState({ noTask: false })
	})

	if (!tasks) return <FormMessage text={'加载中 ...'} />
	return (
		<>
			{noTask && <FormMessage text={'当前没有任务数据'} />}
			<Container flex={1} hidden={noTask} layout='hbox' >
				<Tasks tasks={tasks} onTasksLoaded={handleTasksLoaded} onTaskSwitch={handleTaskSwitch} reloadStamp={reloadStamp} maxFetch={maxFetch} />
				<Task key={currentTask && currentTask.name} task={currentTask} that={that} reloadStamp={reloadStamp} />
				{/* <MyGrid key={currentTask} columns={columns} store={store} onDoubleTap={onDoubleTap} that={that} forViewModel={true} /> */}
			</Container >
		</>
	)
}
const mapStateToProps = ({ loginInfo: { menu } }) => {
	return { menu }
}
export default connect(mapStateToProps, null)(MyTasks)
